import { isFeatureEnable } from '../../../../common/js/features-enabling';
import { RootStore } from '../../../../common/js/stores/root.store';
import {
  AfterVideoLoadedEvent,
  FormatContext,
  ILoadingStrategy
} from './loading-strategy';

export class CustomCloseStrategy implements ILoadingStrategy {
  isRunnable(formatContext: FormatContext): boolean {
    const { closeBtn } = formatContext.config;

    if (!closeBtn) {
      return false;
    }

    return (
      !closeBtn.addSdkCloseButton || isFeatureEnable('videoForceUseCustomClose')
    );
  }

  afterVideoLoaded(event: AfterVideoLoadedEvent): AfterVideoLoadedEvent {
    RootStore.getInstance().adContainerStore.adContainerPort.disableContainerCloseButton(
      true
    );

    return event;
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }
}
